module.exports = __webpack_public_path__ + "img/4S.b40eaf7e.png";